import React from "react";
import Container from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Container";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import Packs from "./Packs";
import Extras from "./Extras";
import DisclaimerContainer from "../../common/disclaimer/DisclaimerContainer";
import { useBnbSelector } from "../../../../redux/store";
import MostPopularExtras from "./MostPopularExtas";
import BasketFinanceTogglePanel from "../../common/basket-financetoggle-panel/BasketFinanceTogglePanel";
import Basket from "../../common/basket/Basket";
import SidebarWrapper from "../../../../../../../common-deprecated/components/SidebarWrapper";
import BottomNavigation from "../../common/nav/BottomNavigation";
import { BASKET_HEADER_TOP_MARGIN } from "../../common/basket/styles/Basket";
import { NAV_PRIMARY_HEIGHT } from "../../../../../../../common-deprecated/styles/v2/lexus/components/Navigation";
import FinanceInsuranceCta from "./FinanceInsuranceCta";
import Finance from "./Finance";
import Insurance from "./Insurance";
import Separator from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Separator";
import { useBnbOptionalLabel } from "../../../../utils/labels";

const MainContent = (): JSX.Element => {
    const { showFinanceInsuranceInPage, enableFinanceCompare } = useBnbSelector((state) => state.bnbSettings);
    const hasVisibleExtra = useBnbSelector((state) => state.items.extras.some((item) => !item.isHidden));
    const packsOrExtrasAvailable = useBnbSelector(
        (state) => state.items.packs.length > 0 || (state.items.extras.length > 0 && hasVisibleExtra),
    );

    const genericePriceDisclaimerCustomize = useBnbOptionalLabel("genericPriceDisclaimerCustomize");

    return (
        <>
            <Container mt={6}>
                {packsOrExtrasAvailable ? (
                    <Flex.Row justifyContent="flex-start">
                        <Flex.Col width={{ xs: 1, lg: 2 / 3 }}>
                            {showFinanceInsuranceInPage && <FinanceInsuranceCta />}
                            {enableFinanceCompare && (
                                <>
                                    <Finance showIntroduction={false} />
                                    <Insurance showIntroduction={false} />
                                </>
                            )}
                            <Packs />
                            <MostPopularExtras />
                            {hasVisibleExtra && <Extras />}
                            {showFinanceInsuranceInPage && !enableFinanceCompare && (
                                <>
                                    <Separator my={4} />
                                    <Finance />
                                    <Insurance />
                                </>
                            )}
                            <BottomNavigation />
                        </Flex.Col>
                        <Flex.Col
                            display={{ xs: "none", lg: "block" }}
                            width={{ xs: 1, lg: 1 / 3 }}
                            position="relative"
                        >
                            <SidebarWrapper top={NAV_PRIMARY_HEIGHT} paddingTop={BASKET_HEADER_TOP_MARGIN}>
                                <BasketFinanceTogglePanel cashPriceDisclaimer={genericePriceDisclaimerCustomize} />
                                <Basket attached cashPriceDisclaimer={genericePriceDisclaimerCustomize} />
                            </SidebarWrapper>
                        </Flex.Col>
                    </Flex.Row>
                ) : (
                    <Flex.Row flexDirection="column" alignItems="center">
                        <Flex.Col width={{ xs: 1, lg: 2 / 3 }}>
                            <Flex.Col p={0} width={1} display={{ xs: "none", lg: "block" }}>
                                <BasketFinanceTogglePanel />
                            </Flex.Col>
                            <Basket attached />
                            {(showFinanceInsuranceInPage || enableFinanceCompare) && (
                                <>
                                    <Finance showIntroduction={!enableFinanceCompare} />
                                    <Insurance showIntroduction={!enableFinanceCompare} />
                                </>
                            )}
                            <BottomNavigation />
                        </Flex.Col>
                    </Flex.Row>
                )}
            </Container>
            <Container>
                <DisclaimerContainer showGenericFinanceDisclaimer hasDarkBackground />
            </Container>
        </>
    );
};

export default MainContent;
